// extracted by mini-css-extract-plugin
export default {"customerPending":"CustomersList_customerPending__sh0cr"};